import { Injectable } from '@angular/core';
import { GeneralHttpService } from '../shared/general-http.service';

@Injectable({
  providedIn: 'root'
})
export class AdmCategoryService {

  private readonly url = "AdmCategorias";

  constructor(private generalHttp: GeneralHttpService) { }

  getListOfCategory(id: number): any {
    return this.generalHttp.getHttp(`${this.url}/${id}`);
  }
}
